<ng-container *ngIf="loadedMe || is403">
  <app-navigation-menu class="nav-menu">
    @if(ready()){
      <main class="main-content" [ngClass]="{'isFullView': isFullView}">
        <router-outlet></router-outlet>
        @if(isNotAgreedTerms){
          <app-license-agreement class="license-overlay"></app-license-agreement>
        }
      </main>
    }
  </app-navigation-menu>
</ng-container>

<app-splash-screen *ngIf="!isDirectAccess" />

<app-spinner />

<app-toast/>
